import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop, Watch } from 'vue-property-decorator';

@Component
export default class GenericSearch extends Vue {
    @Prop({ default: () => [] }) public dataItems: any[];
    @Prop({ default: () => [] }) public properties: string[];
    @Prop({ default: 'sm' }) public size: string;

    private query: string = '';
    private timeout: number;

    @Watch('query')
    public OnQueryChange(val) {
        if (val || val === '') {
            clearTimeout(this.timeout);

            this.timeout = setTimeout(() => {
                const dataItems = this.filterDataItems();
                this.$emit('finished-search', dataItems, val);
            }, 300);
        }
    }

    public setValue(value) {
        this.query = value;
    }

    public filterDataItems() {
        return this.dataItems.filter((item) => {
            for (const property of this.properties) {
                if (this.containsVal(item, property)) {
                    return true;
                }
            }
        });
    }

    public containsVal(object, key): boolean {
        let value = '';
        return Object.keys(object).some((k) => {
            if (k === key) {
                value = object[k];
                return value.toString().toLowerCase().indexOf(this.query.toLowerCase()) > -1;
            }
            if (object[k] && typeof object[k] === 'object' && typeof key !== 'undefined') {
                return this.containsVal(object[k], key.split('.')[1]);
            }
        });
    }
}
